import { render, staticRenderFns } from "./addSucai.vue?vue&type=template&id=9dee8f6e&scoped=true&"
import script from "./addSucai.vue?vue&type=script&lang=js&"
export * from "./addSucai.vue?vue&type=script&lang=js&"
import style0 from "./addSucai.vue?vue&type=style&index=0&id=9dee8f6e&lang=scss&scoped=true&"
import style1 from "./addSucai.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dee8f6e",
  null
  
)

export default component.exports